module.exports = __webpack_public_path__ + "static/img/img-3-8.0c8b186.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-3-8.png
// module id = 7cUr
// module chunks = 0